module.exports = __webpack_public_path__ + "static/media/NovaExpressao.587ff1bb.png";